<template>
  <div class="select-list" v-show="isOpen">
    <ul class="select-list__menu" ref="selectList">
      <li
        role="button"
        aria-labelledby="select-list__item"
        v-for="(item, index) in items"
        :key="`${item}Index`"
        :ref="`items${index}`"
        class="select-list__item"
        :class="
          ({ isActive: index === counterIndex }, { disabled: item?.isDisabled })
        "
        :tabindex="0"
        @click="$emit('selectElOnClick', item)"
        @keydown.up="$emit('moveToPreviousElement')"
        @keydown.down="$emit('moveToNextElement')"
        @keydown.tab="$emit('moveToNextElement')"
        @keydown.enter="$emit('selectElement', item)"
        @keydown.escape="$emit('close', $event)"
      >
        <!-- @blur="$emit('close', $event)" -->
        <slot name="selectItem" :item="item" />

        <!-- default slot -->
        <template v-if="!slots.selectItem">
          {{ item }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useSlots } from "vue";

const props = defineProps({
  items: { type: Array, required: true },
  isOpen: { type: Boolean, default: false },
  isDisabled: { type: Boolean, default: false },
  counterIndex: { type: Number, default: 0 },
});

const slots = useSlots();
</script>
<style scoped lang="scss">
$dropdown-max-height: 200px;

.select-list {
  // position: relative;
  z-index: 1;

  &__menu {
    width: 100%;
    max-width: calc(100% - 2rem);
    max-height: 230px;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    overflow-y: scroll;
    border: 1px solid rgba(244, 244, 245, 0.2);
    background-color: var(--background);
    border-radius: $border-radius-dropdown;
    box-shadow: 3px 2px 2px -2px rgba(0, 0, 0, 0.65);

    &:focus {
      border: 1px solid var(--primary);
    }
  }

  &__item {
    padding: 2rem 1.25rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: var(--dropdown-border);

    span {
      display: flex;
      transition: transform 250ms;
      &:hover {
        transform: translateX(-10px);
      }
    }

    &:hover,
    &:focus-visible,
    &.isActive {
      cursor: pointer;
      background-color: var(--input-background);
      color: var(--text-color);
    }
  }

  &__text {
    .payment-logo {
      max-width: 60px;
    }
  }
}
</style>
